export const TOGGLE_FULLSCREEN = "THEME_OPTIONS/TOGGLE_FULLSCREEN";

export const TOGGLE_RIGHT_SIDEBAR_OPEN = "THEME_OPTIONS/TOGGLE_RIGHT_SIDEBAR_OPEN";
export const OPEN_HISTORY_SIDEBAR = "THEME_OPTIONS/OPEN_HISTORY_SIDEBAR";
export const CLOSE_HISTORY_SIDEBAR = "THEME_OPTIONS/CLOSE_HISTORY_SIDEBAR";

export const toggleFullscreen = (fullscreenEnabled) => ({
  type: TOGGLE_FULLSCREEN,
  fullscreenEnabled,
});

export const toggleRightSidebarOpen = (rightSidebarOpen) => ({
  type: TOGGLE_RIGHT_SIDEBAR_OPEN,
  rightSidebarOpen,
});

export const openHistorySidebar = (item_type, item_id) => ({
  type: OPEN_HISTORY_SIDEBAR,
  item_type,
  item_id,
});

export const closeHistorySidebar = () => ({
  type: CLOSE_HISTORY_SIDEBAR,
});

export default function reducer(
  state = {
    fullscreen: false,
    rightSidebarOpen: false,
    historyItem: null,
  },
  action
) {
  switch (action.type) {
    case TOGGLE_FULLSCREEN:
      return {
        ...state,
        fullscreenEnabled: action.fullscreenEnabled,
      };
    case TOGGLE_RIGHT_SIDEBAR_OPEN:
      return {
        ...state,
        rightSidebarOpen: action.rightSidebarOpen,
        historyItem: null,
      };
    case OPEN_HISTORY_SIDEBAR:
      return {
        ...state,
        historyItem: { item_type: action.item_type, item_id: action.item_id },
      };
    case CLOSE_HISTORY_SIDEBAR:
      return {
        ...state,
        historyItem: null,
      };

    default:
  }
  return state;
}
